import { render, staticRenderFns } from "./AllotmentEditionTable.vue?vue&type=template&id=57295745&scoped=true&"
import script from "./AllotmentEditionTable.vue?vue&type=script&lang=js&"
export * from "./AllotmentEditionTable.vue?vue&type=script&lang=js&"
import style0 from "./AllotmentEditionTable.vue?vue&type=style&index=0&id=57295745&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57295745",
  null
  
)

export default component.exports